(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('purchase-status', {
            parent: 'entity',
            url: '/purchase-status?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.purchaseStatus.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/purchase-status/purchase-statuses.html',
                    controller: 'PurchaseStatusController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('purchaseStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('purchase-status-detail', {
            parent: 'entity',
            url: '/purchase-status/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.purchaseStatus.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/purchase-status/purchase-status-detail.html',
                    controller: 'PurchaseStatusDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('purchaseStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PurchaseStatus', function($stateParams, PurchaseStatus) {
                    return PurchaseStatus.get({id : $stateParams.id});
                }]
            }
        })
        .state('purchase-status.new', {
            parent: 'purchase-status',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase-status/purchase-status-dialog.html',
                    controller: 'PurchaseStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                cancellable: null,
                                code: null,
                                isEditable: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('purchase-status', null, { reload: true });
                }, function() {
                    $state.go('purchase-status');
                });
            }]
        })
        .state('purchase-status.edit', {
            parent: 'purchase-status',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase-status/purchase-status-dialog.html',
                    controller: 'PurchaseStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PurchaseStatus', function(PurchaseStatus) {
                            return PurchaseStatus.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('purchase-status', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('purchase-status.delete', {
            parent: 'purchase-status',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase-status/purchase-status-delete-dialog.html',
                    controller: 'PurchaseStatusDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PurchaseStatus', function(PurchaseStatus) {
                            return PurchaseStatus.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('purchase-status', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
